const DefaultIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
    <g filter="url(#filter0_d_33_1312)">
      <path
        d="M5.9375 10.9375C5.9375 8.17608 8.17608 5.9375 10.9375 5.9375H19.0625C21.8239 5.9375 24.0625 8.17608 24.0625 10.9375V19.0625C24.0625 21.8239 21.8239 24.0625 19.0625 24.0625H10.9375C8.17608 24.0625 5.9375 21.8239 5.9375 19.0625V10.9375Z"
        fill="white"
      />
      <path
        d="M5.9375 10.9375C5.9375 8.17608 8.17608 5.9375 10.9375 5.9375H19.0625C21.8239 5.9375 24.0625 8.17608 24.0625 10.9375V19.0625C24.0625 21.8239 21.8239 24.0625 19.0625 24.0625H10.9375C8.17608 24.0625 5.9375 21.8239 5.9375 19.0625V10.9375Z"
        stroke="#A9A9A9"
        strokeWidth="1.875"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_33_1312"
        x="2.5"
        y="3.75"
        width="25"
        height="25"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.25" />
        <feGaussianBlur stdDeviation="1.25" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0901961 0 0 0 0.05 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_33_1312" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_33_1312" result="shape" />
      </filter>
    </defs>
  </svg>
)

export default DefaultIcon
